(() => {
  const initializeHero = (hero) => {
    if (hero.dataset.amoreHomeHeroReady === 'true') return;

    const track = hero.querySelector('[data-amore-home-hero-track]');
    const segments = hero.querySelectorAll('[data-amore-home-hero-segments] i');
    if (!track) return;

    hero.dataset.amoreHomeHeroReady = 'true';
    track.addEventListener('scroll', () => {
      const index = track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
      segments.forEach((segment, segmentIndex) => segment.classList.toggle('is-active', segmentIndex === index));
    }, { passive: true });

    const mobileLinkFrame = hero.querySelector('[data-amore-mobile-href]');
    if (mobileLinkFrame) {
      const desktopHref = mobileLinkFrame.getAttribute('href');
      const mobileHref = mobileLinkFrame.dataset.amoreMobileHref;
      const mql = window.matchMedia('(max-width: 899px)');
      const syncHref = (matches) => mobileLinkFrame.setAttribute('href', matches ? mobileHref : desktopHref);
      syncHref(mql.matches);
      mql.addEventListener('change', (event) => syncHref(event.matches));
    }
  };

  const initializeHeroes = (root = document) => {
    root.querySelectorAll('[data-amore-home-hero]').forEach(initializeHero);
  };

  // HOME-PORT-02: мягкая загрузка — кадр появляется из размытия 13px за
  // 0,7с (CSS), здесь только переключатель класса по факту загрузки img.
  // Лента вещей идёт через общий сниппет карточки (вне зоны) и сюда не
  // включена — см. amore-home.css.
  const SOFT_LOAD_SELECTOR =
    '.amore-home-hero__image, .amore-home-atelier__image, .amore-home-instagram__image, .amore-home-pause__image, .amore-home-more__image';

  const initializeSoftLoadImage = (img) => {
    if (img.dataset.amoreSoftLoadReady === 'true') return;
    img.dataset.amoreSoftLoadReady = 'true';
    const reveal = () => img.classList.add('is-amore-loaded');
    if (img.complete) {
      requestAnimationFrame(reveal);
    } else {
      img.addEventListener('load', reveal, { once: true });
    }
  };

  const initializeSoftLoad = (root = document) => {
    root.querySelectorAll(SOFT_LOAD_SELECTOR).forEach(initializeSoftLoadImage);
  };

  initializeHeroes();
  initializeSoftLoad();
  document.addEventListener('shopify:section:load', (event) => {
    initializeHeroes(event.target);
    initializeSoftLoad(event.target);
  });
})();
